import * as React from 'react';
import { withNavigation } from '../../components/hocs/withNavigation';
import { NavigationSpecs } from '../../states/NavigationState';
import { observer, Provider } from 'mobx-react';
import { GlobalStatesV3 } from '../../../commonv3/states/GlobalStatesV3';
import { V3Routes } from '../../routes';
import { Route, RouteComponentProps, Switch } from 'react-router';
import { ForgotPasswordPane } from '../../components/organisms/passwords/ForgotPasswordPane';
import { observable } from 'mobx';
import { ResetPasswordPageState } from './states/ResetPasswordPageState';
import { ResetCodePane } from '../../components/organisms/passwords/ResetCodePane';
import { ResetPasswordPane } from '../../components/organisms/passwords/ResetPasswordPane';

type Props = RouteComponentProps;

@withNavigation(NavigationSpecs.application())
@observer
export class ResetPasswordPage extends React.Component<Props> {
    @observable pageState = new ResetPasswordPageState(GlobalStatesV3.routing);

    componentDidMount(): void {
        if (GlobalStatesV3.currentUser.isSignedIn()) {
            GlobalStatesV3.routing.push(V3Routes.home().stringify());
        }
    }

    render() {
        return (
            <Provider pageState={this.pageState}>
                <Switch>
                    <Route exact path={V3Routes.forgotPassword().stringify()} component={ForgotPasswordPane} />
                    <Route exact path={V3Routes.validateResetCode().stringify()} component={ResetCodePane} />
                    <Route exact path={V3Routes.resetPassword().stringify()} component={ResetPasswordPane} />
                </Switch>
            </Provider>
        );
    }
}
